var React = require('react');

function PaintRoller (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 160H32a32 32 0 0 1-32-32V32A32 32 0 0 1 32 0h352a32 32 0 0 1 32 32v96a32 32 0 0 1-32 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512 128v64a96 96 0 0 1-96 96H256v32a32 32 0 0 1 32 32v128a32 32 0 0 1-32 32h-64a32 32 0 0 1-32-32V352a32 32 0 0 1 32-32v-32a64 64 0 0 1 64-64h160a32 32 0 0 0 32-32V64a64 64 0 0 1 64 64z","className":"fa-primary","key":2})]);
}

PaintRoller.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = PaintRoller;

PaintRoller.default = PaintRoller;
